import { render, staticRenderFns } from "./components.vue?vue&type=template&id=1c447284&scoped=true&"
import script from "./components.vue?vue&type=script&lang=js&"
export * from "./components.vue?vue&type=script&lang=js&"
import style0 from "./components.vue?vue&type=style&index=0&id=1c447284&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c447284",
  null
  
)

export default component.exports